import { CollectionBannerWithLoader } from './loaders';

export const BannerCollections = () => <CollectionBannerWithLoader />;
